import { Theme } from "@mui/material";

// Ariva's primary.light is practically its sidebar colour, so the default
// pill would blend into the header.
export const plusBadgeColors = (theme: Theme) =>
  theme.type === "ariva_de"
    ? {
        color: theme.palette.primary.main,
        background: theme.palette.common.white,
      }
    : {
        color: theme.palette.common.black,
        background: theme.palette.primary.light,
      };
